import React from 'react';
import { connect } from 'react-redux';
import { translate, changeLocale } from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';

const styles = {
    label: { width: '10em', display: 'inline-block' },
    button: { margin: '1em' },
};

const accessibility = () => (
        <div dir='ltr'>
            <h1>Call2all.co.il Accessibility Statement</h1>


            <br /><br />
            B.H.

            <br /><br />

            <h2>General</h2>
            Call2all.co.il strives to ensure that its services are accessible to people with disabilities. Call2all.co.il has invested a significant amount of resources to help ensure that its website is made easier to use and more accessible for people with disabilities, with the strong belief that every person has the right to live with dignity, equality, comfort and independence.

            <h2>Accessibility on Call2all.co.il</h2>
            Call2all.co.il makes available the <a href="https://UserWay.org" alt="Free Website Accessibility Widget" title="Free Website Accessibility Widget">UserWay Website Accessibility Widget</a> that is powered by a dedicated accessibility server. The software allows Call2all.co.il to improve its compliance with the Web Content Accessibility Guidelines (WCAG 2.1).

            <h2>Enabling the Accessibility Menu</h2>
            The Call2all.co.il accessibility menu can be enabled by clicking the accessibility menu icon that appears on the corner of the page. After triggering the accessibility menu, please wait a moment for the accessibility menu to load in its entirety.

            <h2>Disclaimer</h2>
            Call2all.co.il continues its efforts to constantly improve the accessibility of its site and services in the belief that it is our collective moral obligation to allow seamless, accessible and unhindered use also for those of us with disabilities. 

            <br /><br />

            Despite our efforts to make all pages and content on Call2all.co.il fully accessible, some content may not have yet been fully adapted to the strictest accessibility standards. This may be a result of not having found or identified the most appropriate technological solution.

            <h2>Here For You</h2>
            If you are experiencing difficulty with any content on Call2all.co.il or require assistance with any part of our site, please contact us during normal business hours as detailed below and we will be happy to assist.

            <h2>Contact Us</h2>
            If you wish to report an accessibility issue, have any questions or need assistance, please contact Call2all.co.il Customer Support as follows: 

            <br /><br />

            Email: <a href="mailto:y0773137770@gmail.com">y0773137770@gmail.com</a>
        </div>
);

const mapStateToProps = state => ({
    theme: state.theme,
    locale: state.i18n.locale,
});

const enhance = compose(
    connect(
        mapStateToProps,
        {
            changeLocale,
        }
    ),
    translate,
    withStyles(styles)
);

export default enhance(accessibility);